{
  "globe": {
    "title": "Projek anda",
    "loading": "Memuatkan projek anda",
    "placeholder": "Menyediakan glob",
    "unavailable": "Glob memerlukan grafik perkakasan, yang tidak disediakan oleh pelayar ini. Projek anda disenaraikan di bawah.",
    "pinLabel": "{{name}}, pada glob",
    "flyTo": "Tunjukkan {{name}} pada glob",
    "zoomIn": "Zum masuk",
    "zoomOut": "Zum keluar",
    "reset": "Set semula paparan"
  },
  "card": {
    "updated": "Dikemas kini {{when}}",
    "noSites": "Belum ada tapak",
    "sites_one": "{{count}} tapak",
    "sites_other": "{{count}} tapak",
    "lastRun": "Larian terakhir {{when}}",
    "neverRun": "Belum ada larian",
    "members_one": "{{count}} ahli",
    "members_other": "{{count}} ahli",
    "noLocation": "Belum ada lokasi",
    "open": "Buka {{name}}"
  },
  "visibility": {
    "private": "Persendirian",
    "org": "Organisasi",
    "public": "Awam"
  },
  "empty": {
    "title": "Belum ada projek",
    "description": "Projek menyimpan tapak yang anda analisis, larian terhadapnya, dan segala yang dihasilkan. Cipta satu untuk bermula.",
    "action": "Projek baharu"
  },
  "seeAll": "Lihat semua projek",
  "openTools": "Buka Alatan",
  "newProject": "Projek baharu",
  "workspace": {
    "backToProjects": "Projek",
    "layers": "Lapisan",
    "sites": {
      "version": "v{{version}}",
      "versionHint": "Sempadan telah disunting. Larian terdahulu kekal terikat pada versi yang digunakannya.",
      "area": "{{area, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha · {{crs}}",
      "hectares": "{{value, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha",
      "zoomTo": "Zum ke tapak ini",
      "actions": "Tindakan untuk {{name}}",
      "rename": "Namakan semula",
      "history": "Sejarah sempadan",
      "delete": "Padam",
      "saveBoundary": "Simpan sempadan",
      "saveTitle": "Simpan sempadan ini",
      "saveDescription": "Luas diukur pada pelayan, dalam unjuran tapak akan disimpan.",
      "save": "Simpan tapak",
      "saveFailed": "Sempadan tidak disimpan",
      "saveError": "Berlaku masalah semasa menyimpan sempadan. Tiada apa-apa disimpan.",
      "rejected": "Pelayan menolak sempadan ini. Ia mungkin bersilang sendiri, atau di luar saiz yang dibenarkan.",
      "measuring": "Mengukur pada pelayan…",
      "name": "Nama",
      "renameTitle": "Namakan semula tapak",
      "deleteTitle": "Padam tapak",
      "deleteConfirm": "Padam “{{name}}” dan semua yang dikira terhadapnya? Ini tidak boleh dibatalkan.",
      "historyTitle": "{{name}} — sejarah sempadan",
      "historyDescription": "Menyunting sempadan mencipta versi baharu. Larian kekal terikat pada versi yang digunakannya.",
      "loadingHistory": "Memuatkan sejarah…",
      "versionColumn": "Versi",
      "changedAt": "Diubah",
      "current": "semasa"
    },
    "noSites": "Belum ada tapak",
    "noSitesHint": "Lukis sempadan dengan alat poligon atau segi empat, kemudian simpannya.",
    "mapPlaceholder": "Peta akan tiba dengan P1-WEB-05",
    "mapPlaceholderHint": "Rangka ruang kerja telah sedia. Peta asas, alat lukisan dan lapisan adalah tugasan seterusnya.",
    "openPanel": "Tunjukkan panel sisi",
    "closePanel": "Sembunyikan panel sisi",
    "runs": "Larian dan aktiviti",
    "runsActive": "Larian dan aktiviti, {{count}} sedang berjalan",
    "runsPlaceholder": "Larian akan dipaparkan di sini setelah API larian tiba (P1-PLAT-07).",
    "sections": "Bahagian ruang kerja",
    "tabs": {
      "search": "Cari",
      "imagery": "Imejan",
      "analyse": "Analisis",
      "design": "Reka Bentuk",
      "discrepancy": "Percanggahan",
      "reports": "Laporan",
      "chat": "Sembang"
    },
    "mapTools": "Alat peta",
    "basemap": {
      "label": "Peta asas",
      "googleMap": "Peta Google",
      "googleSatellite": "Satelit Google",
      "satellite": "Satelit",
      "streets": "OSM",
      "blank": "Kosong",
      "esri": "Satelit Esri"
    },
    "coordinates": {
      "position": "{{lat}}, {{lng}}",
      "away": "Gerakkan penunjuk ke atas peta",
      "computeCrs": "Keluasan dikira dalam {{crs}}",
      "label": "Kedudukan penunjuk",
      "computeCrsLocal": "Keluasan dikira dalam grid negeri setiap tapak"
    },
    "map": {
      "zoomIn": "Zum masuk",
      "zoomOut": "Zum keluar",
      "resetBearing": "Tetapkan semula arah ke utara",
      "fullscreen": "Skrin penuh",
      "unavailable": "Peta memerlukan grafik perkakasan, yang tidak disediakan oleh pelayar ini."
    },
    "draw": {
      "label": "Alat lukis",
      "tools": {
        "select": "Pilih dan sunting",
        "polygon": "Lukis poligon",
        "rectangle": "Lukis segi empat",
        "measure-line": "Ukur jarak",
        "measure-area": "Ukur luas"
      },
      "undo": "Buat asal",
      "redo": "Buat semula",
      "clear": "Kosongkan semua bentuk",
      "area": "Luas",
      "perimeter": "Perimeter",
      "vertices": "Bucu",
      "corners_one": "{{count}} bucu",
      "corners_other": "{{count}} bucu",
      "overMax": "melebihi had {{max, number}} ha",
      "hectares": "{{value, number(minimumFractionDigits: 2; maximumFractionDigits: 2)}} ha",
      "metres": "{{value, number(maximumFractionDigits: 0)}} m",
      "hint": "Klik untuk meletakkan setiap bucu. Klik dua kali pada bucu terakhir untuk selesai.",
      "hintRectangle": "Seret kotak, atau klik satu bucu kemudian bucu bertentangan.",
      "hintSelect": "Klik bentuk untuk menyuntingnya. Seret bucu untuk mengalihkannya, atau titik tengah untuk menambah satu.",
      "hintMeasureLine": "Klik di sepanjang laluan. Klik dua kali pada titik terakhir untuk selesai.",
      "hintMeasureArea": "Klik setiap bucu. Klik dua kali pada yang terakhir untuk selesai.",
      "preview": "Pratonton pada elipsoid WGS84 · keluasan yang disimpan diukur dalam grid negeri tapak",
      "computedIn": "Dikira dalam {{crs}}"
    },
    "measure": {
      "title": "Ukur",
      "distance": "Jarak",
      "area": "Luas",
      "distanceUnit": "Unit jarak",
      "areaUnit": "Unit luas",
      "clear": "Kosongkan semua ukuran",
      "value": "{{value, number}}",
      "scratch": "Kerja kasar sahaja — ukuran tidak disimpan bersama tapak.",
      "units": {
        "m": "m",
        "km": "km",
        "ft": "ka",
        "m2": "m²",
        "ha": "ha",
        "acre": "ekar"
      }
    },
    "shortcuts": {
      "title": "Pintasan papan kekunci",
      "description": "Semua yang boleh dilakukan ruang kerja daripada papan kekunci.",
      "groups": {
        "tools": "Alat",
        "drawing": "Semasa melukis",
        "panels": "Panel"
      },
      "actions": {
        "select": "Pilih dan sunting",
        "polygon": "Lukis poligon",
        "rectangle": "Lukis segi empat",
        "measure": "Ukur jarak",
        "cancel": "Batalkan bentuk semasa",
        "undo": "Buat asal",
        "redo": "Buat semula",
        "layers": "Tunjuk atau sembunyikan panel lapisan",
        "help": "Tunjukkan senarai ini"
      },
      "keys": {
        "shift": "Shift",
        "escape": "Esc"
      },
      "open": "Pintasan papan kekunci"
    },
    "snap": {
      "label": "Lekat pada kadaster",
      "hint": "Lekatkan bucu pada sempadan lot berwarta berdekatan.",
      "pending": "Tiada kadaster dikonfigurasikan. P1-GEO-07 menyediakan sempadan lot untuk dilekatkan."
    },
    "search": {
      "label": "Cari tempat",
      "placeholder": "Cari tempat, atau tampal lat, lng",
      "clear": "Kosongkan",
      "results": "Tempat ditemui",
      "none": "Tiada tempat ditemui. Cuba perkataan lain.",
      "failed": "Carian tempat tidak tersedia buat masa ini.",
      "coordinates": "Koordinat",
      "title": "Cari",
      "hint": "Taip tempat di bar atas, atau cari apa yang berhampiran pusat peta.",
      "recent": "Tempat terkini",
      "rating": "{{rating}} ({{count}})",
      "openNow": "Dibuka sekarang",
      "closedNow": "Ditutup sekarang",
      "hours": "Waktu operasi",
      "openInMaps": "Buka di Google Maps",
      "nearby": "Berhampiran",
      "nearbyMap": "Berhampiran pusat peta",
      "nearbyNone": "Tiada jenis ini dalam 2 km.",
      "categories": {
        "schools": "Sekolah",
        "health": "Kesihatan",
        "worship": "Rumah ibadat",
        "shops": "Kedai & pasar",
        "transport": "Pengangkutan",
        "parks": "Taman"
      }
    },
    "hideLayers": "Sembunyi lapisan",
    "showLayers": "Tunjuk lapisan"
  },
  "create": {
    "title": "Projek baharu",
    "subtitle": "Projek menyimpan tapak yang anda analisis dan segala yang dihasilkannya.",
    "name": "Nama projek",
    "description": "Penerangan",
    "descriptionHint": "Pilihan. Apa yang diliputi projek ini, untuk rakan sekerja yang membukanya kemudian.",
    "visibility": "Siapa boleh melihatnya",
    "visibilityHint": "Persendirian mengekalkannya kepada anda dan sesiapa yang anda tambah. Ini boleh diubah kemudian.",
    "submit": "Cipta projek",
    "submitting": "Sedang mencipta",
    "close": "Tutup",
    "aoiLater": "Sempadan awal boleh dimuat naik setelah alat tapak tiba (P1-PLAT-02).",
    "nameRequired": "Masukkan nama projek"
  },
  "actions": {
    "label": "Tindakan untuk {{name}}",
    "open": "Buka",
    "rename": "Namakan semula",
    "visibility": "Ubah siapa boleh melihatnya",
    "members": "Urus ahli",
    "archive": "Arkibkan",
    "unarchive": "Pulihkan daripada arkib",
    "delete": "Padam",
    "duplicateUnavailable": "Penduaan akan tiba dengan P1-PLAT-02"
  },
  "rename": {
    "title": "Namakan semula projek",
    "submit": "Simpan"
  },
  "changeVisibility": {
    "title": "Siapa boleh melihat projek ini",
    "submit": "Simpan"
  },
  "deleteConfirm": {
    "title": "Padam projek ini?",
    "description": "Ia boleh dipulihkan selama 30 hari. Tapak, larian dan hasilnya turut dipadam dan kembali bersamanya.",
    "confirm": "Padam projek"
  },
  "archived": "Diarkibkan",
  "list": {
    "title": "Semua projek",
    "search": "Cari projek",
    "searchPlaceholder": "Cari mengikut nama",
    "view": "Paparan",
    "viewGrid": "Grid",
    "viewList": "Senarai",
    "cardSize": "Saiz kad",
    "filterVisibility": "Keterlihatan",
    "filterState": "Status",
    "anyVisibility": "Sebarang keterlihatan",
    "state": {
      "active": "Aktif",
      "archived": "Diarkibkan",
      "all": "Aktif dan diarkibkan"
    },
    "sort": "Susun mengikut",
    "sortUpdated": "Terkini dikemas kini",
    "sortCreated": "Terkini dicipta",
    "sortName": "Nama",
    "count_one": "{{count}} projek",
    "count_other": "{{count}} projek",
    "page": "Halaman {{page}} daripada {{pages}}",
    "previous": "Halaman sebelumnya",
    "next": "Halaman seterusnya",
    "noMatches": {
      "title": "Tiada projek sepadan",
      "description": "Tiada apa-apa di sini yang menepati penapis itu. Luaskan penapis, atau kosongkan carian.",
      "clear": "Kosongkan penapis"
    },
    "columns": {
      "name": "Projek",
      "sites": "Tapak",
      "lastRun": "Larian terakhir",
      "owner": "Pemilik",
      "visibility": "Keterlihatan",
      "updated": "Dikemas kini",
      "actions": "Tindakan"
    }
  },
  "design": {
    "eyebrow": "{{site}} / Perancangan",
    "eyebrowNoSite": "Perancangan",
    "tabs": {
      "describe": "Cadangan",
      "scenarios": "Hasil"
    },
    "describe": {
      "title": "Terokai cadangan",
      "subtitle": "Huraikan bagaimana anda mahu membangunkan kawasan ini.",
      "siteMeta": "{{area}} ha",
      "noSites": "Lukis atau muat naik tapak pada peta untuk bermula.",
      "heading": "Huraikan cadangan anda",
      "lead": "Tetapkan hala tuju dengan kata-kata anda sendiri.",
      "prompt": "Arahan perancangan",
      "promptHint": "Senario dalam perkataan. Ubah, atau tulis sendiri dalam Bahasa Melayu atau Inggeris.",
      "promptPlaceholder": "Bangunkan tapak ini sebagai pembangunan bercampur: 20% industri, 30% tanah lapang, 50% kediaman.",
      "reference": "Lapisan rujukan",
      "referenceNone": "Tiada",
      "referenceRun": "Analisis guna tanah · {{site}}",
      "generate": "Jana senario",
      "generating": "Sedang menjana…",
      "failed": "Senario tidak dapat dijana.",
      "scenario": "Senario",
      "scenarioOwn": "Huraian saya sendiri",
      "promptEdited": "Diubah: huraian anda sendiri akan digunakan.",
      "capture": "Imejan",
      "noCaptures": "Tapak ini belum ada imejan sub-meter. Peroleh tangkapan Esri atau Google di tab Imejan."
    },
    "scenarios": {
      "title": "Hasil",
      "subtitle": "Semak setiap senario pada peta.",
      "empty": "Jana senario dahulu untuk melihatnya di sini.",
      "goDescribe": "Kembali ke cadangan",
      "selected": "Konsep {{n}} dipilih. Peta ialah lapisan peruntukan ilustratif, bukan pelan pembangunan yang dijana.",
      "editPrompt": "Sunting arahan",
      "reviewConstraints": "Semak kekangan",
      "constraintsSoon": "Semakan kekangan akan datang."
    },
    "steps": {
      "label": "Langkah cadangan",
      "site": "Tapak",
      "capture": "Tangkapan",
      "scenario": "Senario"
    }
  },
  "discrepancy": {
    "eyebrow": "{{site}} / Pematuhan",
    "eyebrowNoSite": "Pematuhan",
    "title": "Semak dengan pelan yang diluluskan",
    "subtitle": "Bandingkan apa yang ada di lapangan dengan apa yang diluluskan.",
    "site": "Tapak",
    "plan": "Pelan yang diluluskan",
    "summary": {
      "total": "Percanggahan",
      "high": "Tinggi",
      "medium": "Sederhana"
    },
    "findings": "Dapatan",
    "compare": {
      "title": "Diluluskan lwn diperhatikan",
      "approved": "Diluluskan",
      "observed": "Diperhatikan"
    },
    "landUse": {
      "residential": "Kediaman",
      "openSpace": "Ruang terbuka",
      "commercial": "Komersial",
      "roads": "Jalan"
    },
    "run": "Jalankan semakan",
    "notConnected": "Semakan belum disambungkan — ini pratonton dengan dapatan contoh."
  },
  "chat": {
    "eyebrow": "{{site}} / Pembantu",
    "eyebrowNoSite": "Pembantu",
    "title": "Tanya tentang tapak ini",
    "subtitle": "Soalan tentang litupan bumi, perubahan dan perancangan, dijawab daripada analisis anda.",
    "badge": "Pratonton · data contoh",
    "thread": "Perbualan",
    "thisSite": "tapak ini",
    "suggestions": "Soalan dicadangkan",
    "prompts": {
      "compare": "Bandingkan 2019 dan 2025",
      "treeLoss": "Di mana litupan pokok hilang?",
      "planningNote": "Draf nota perancangan"
    },
    "placeholder": "Tanya apa saja — cth. litupan pokok hilang sejak 2019?",
    "send": "Hantar",
    "composer": "Soalan anda",
    "messages": {
      "q1": "Ringkaskan litupan bumi di {{site}}",
      "a1": "Dalam contoh ini, litupan bumi {{site}} kelihatan seperti ini.",
      "q2": "Apa yang bertukar menjadi bangunan sejak 2019?",
      "a2": "Kebanyakan bangunan baharu menggantikan tanah kosong, diikuti pokok dan rumput.",
      "notConnected": "Sembang belum disambungkan — ini pratonton. Soalan anda akan dijawab di sini apabila pembantu sudah aktif."
    },
    "stats": {
      "area": "Luas tapak",
      "builtUp": "Kawasan binaan",
      "treeCover": "Litupan pokok",
      "netBuilt": "Binaan baharu bersih"
    },
    "donut": {
      "aria": "Litupan bumi: {{parts}}",
      "part": "{{name}} {{share}}%"
    },
    "bars": {
      "title": "Menjadi {{class}} sejak 2019",
      "ha": "{{value}} ha"
    }
  },
  "dashboard": {
    "breadcrumb": "Papan pemuka",
    "title": "Litupan tanah mengikut masa",
    "site": "Tapak",
    "sample": "Pratonton · data contoh",
    "sampleNote": "Tarikh yang belum dianalisis menunjukkan angka contoh.",
    "loading": "Memuatkan garis masa…",
    "loadFailed": "Garis masa tidak dapat dimuatkan.",
    "retry": "Cuba lagi",
    "empty": {
      "title": "Belum ada imejan",
      "body": "Peroleh tangkapan tapak ini di bahagian Imejan ruang kerja, dan ia akan muncul di sini.",
      "action": "Buka ruang kerja"
    },
    "timeline": {
      "label": "Tarikh tangkapan",
      "analysed": "Dianalisis",
      "sampled": "Angka contoh",
      "marker": "{{date}} · {{kind}}",
      "markerProvider": "{{date}} · {{provider}} · {{kind}}",
      "compare": "Banding dua tarikh",
      "compareNeedsTwo": "Perbandingan memerlukan dua tarikh.",
      "before": "Sebelum",
      "after": "Selepas"
    },
    "map": {
      "label": "Peta",
      "unavailable": "Peta tidak tersedia dalam pelayar ini. Angka di bawah tidak terjejas.",
      "noOverlay": "Tiada lapisan litupan tanah pada tarikh ini: tangkapan belum dianalisis.",
      "noImagery": "Tarikh ini tiada tangkapan untuk dilukis; litupan tanah ditunjukkan di atas peta asas.",
      "failed": "Tangkapan tidak dapat dimuatkan."
    },
    "figures": {
      "title": "Angka utama",
      "on": "{{date}}",
      "between": "{{before}} → {{after}}",
      "sampleOn": "{{date}} · angka contoh",
      "sampleDate": "{{date}} (contoh)",
      "builtUp": "Tepu bina",
      "green": "Litupan hijau",
      "water": "Air",
      "bare": "Tanah kosong",
      "buildings": "Bangunan",
      "ha": "{{value}} ha",
      "ofSite": "{{value}}% daripada tapak",
      "share": "{{value}}%",
      "fromTo": "{{before}} → {{after}} ha",
      "countFromTo": "{{before}} → {{after}}"
    },
    "donut": {
      "title": "Bahagian tapak"
    },
    "trend": {
      "title": "Bahagian tapak mengikut masa",
      "note": "Disusun kepada keseluruhan tapak. Tanda berongga ialah angka contoh; tuding untuk setiap kelas, klik untuk membuka tarikh.",
      "aria": "{{name}}: {{from}}% pada {{first}}, {{to}}% pada {{last}}",
      "ha": "{{value}} ha"
    },
    "change": {
      "title": "Perubahan antara dua tarikh",
      "sampleNote": "Sekurang-kurangnya satu daripada tarikh ini menggunakan angka contoh, jadi perubahan ini sekadar gambaran.",
      "bars": "Pertambahan atau pengurangan bagi setiap kelas, dalam hektar",
      "class": "Kelas",
      "before": "Sebelum (ha)",
      "after": "Selepas (ha)",
      "deltaHa": "Perubahan (ha)",
      "deltaPp": "Perubahan (mata)",
      "row": "{{name}}: {{delta}} ha"
    },
    "fullscreen": {
      "enter": "Skrin penuh",
      "exit": "Keluar dari skrin penuh"
    }
  }
}
